import { render, staticRenderFns } from "./listjj.vue?vue&type=template&id=babccc34&scoped=true"
import script from "./listjj.vue?vue&type=script&lang=js"
export * from "./listjj.vue?vue&type=script&lang=js"
import style0 from "./listjj.vue?vue&type=style&index=0&id=babccc34&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babccc34",
  null
  
)

export default component.exports